import template from './print_location_barcodes.html';
import controller from './print_location_barcodes.controller';
import './print_location_barcodes.scss';

let printLocationBarcodesComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller
};

export default printLocationBarcodesComponent;


// WEBPACK FOOTER //
// ./client/app/components/location/print/print_location_barcodes.component.js